module.exports = __webpack_public_path__ + "media/images/hero-pharma-and-med-tech-fc3a57494ae315b4088e2f4490b42c75.png";